import { React, useRef, useState } from "react";
import styles from "../style";
import Services from '../components/Services';
import Heroserv from "../components/Heroserv";
import Footer from "../components/Footer";
import Thesis from "../components/Thesis";

const Expertise = () => {
  return (
    <div className="bg-tertiary w-full ">
      <Heroserv /> 
      <Thesis />      
      <Services />
      <Footer />   
    </div>
  )
}
export default Expertise;